import axios from "axios";

const getTours = async (token) => {
  const path = `${process.env.REACT_APP_BACKEND_API_URL}/tours/auth`;

  try {
    const response = await axios.get(path, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    // console.log(response);
    return response;
  } catch (error) {
    console.log(error.response);
    return error.response;
  } 
};

export default getTours;